module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":{"unauthorized":"The credentials provided are incorrect. Check your credentials and try again."}}}')
  delete Component.options._Ctor
}
